import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_AIRPORT'),
  ...asyncTypes('CREATE_AIRPORT'),
  ...asyncTypes('ARCHIVE_AIRPORT'),
  ...asyncTypes('UNARCHIVE_AIRPORT')
};

export default TYPES;
